<template>

  <popup
    :buttonStyle="this.existing ? 'success' : 'primary'"
    :heading="heading"
    :centerButton="true"
    :showText="showText"
    :buttonText="button"
    buttonIcon="fa fa-plus"
    :disableButton="!isManager('admin|finance|management') || readOnly"
    @save="onSaveDialog"
    @close="onCloseDialog">

  <el-tabs>
    <el-tab-pane v-if="!adding" label="Insurer">

    <el-form ref="insurerForm" v-model="insurer">

    <el-row align="middle">
      <el-col :span="adding ? 20 : 18">
        <select-insurer label="" v-model="insurer.organisation_id" :callback="orgChange" />
      </el-col>

      <el-col align="center" :span="adding ? 0 : 3">
        <el-button v-if="!adding" type="warning" icon="fa fa-edit" @click="onEdit" :disabled="editing">Update</el-button>
      </el-col>

      <el-col align="center" :span="adding ? 0 : 3">
        <el-button v-if="!adding" type="primary" icon="fa fa-plus" @click="onAdd" :disabled="!searched">Add New...</el-button>
      </el-col>
    </el-row>

    <el-form-item label="Name" v-if="adding">
      <el-input :rows="3" v-model="organisation.name" placeholder="Name">
        <template slot="prepend"><i class="fa fa-user"></i></template>
      </el-input>
    </el-form-item>

    <el-form-item label="Address">
      <el-input type="textarea" :rows="3"
      v-model="organisation.address"
      placeholder="Address" :disabled="!editing">
        <template slot="prepend"><i class="fa fa-home"></i></template>
      </el-input>
    </el-form-item>

    <el-row>
      <el-col :span="6">
        <el-form-item label="Post Code">
          <el-input  v-model="organisation.postCode"
          placeholder="Post Code"  :disabled="!editing">
            <template slot="prepend"><i class="fa fa-barcode"></i></template>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :span="7" :offset="3">
        <el-form-item label="Phone">
          <el-input type="phone" v-model="organisation.phone"
          placeholder="Phone" :disabled="!editing">
            <template slot="prepend"><i class="fa fa-earphone"></i></template>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :span="7" :offset="1">
        <el-form-item label="E-Mail">
          <el-input  type="email"
          v-model="organisation.email"
          placeholder="E-Mail"  :disabled="!editing">
            <template slot="prepend"><i class="fa fa-envelope"></i></template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <h3>Bank Details</h3>
    <el-row>
      <el-col :span="8">
        <el-form-item label="Beneficiary Name">
          <el-input placeholder="Beneifciary Name"
          v-model='insurer.beneficaryName'  :disabled="!editing" />
        </el-form-item>
      </el-col>

      <el-col :span="7" :offset="1">
        <el-form-item label="Bank Name">
          <el-input placeholder="Bank Name"
          v-model='insurer.bankName'  :disabled="!editing" />
        </el-form-item>
      </el-col>

      <el-col :span="7" :offset="1">
        <el-form-item label='Bank Account'>
          <el-input placeholder="Account No."
          v-model='insurer.bankAccount'  :disabled="!editing" />
        </el-form-item>
      </el-col>
    </el-row>

  </el-form>

</el-tab-pane>


<el-tab-pane label  ="Agreement">
  <el-form ref='landAgreementFrom'  v-model='insurer' align="left" label-position='top'>
<!--
    <h3>Insurance Agent</h3>
    <el-row>
      <el-col :span="8">
        <el-form-item label="Insurance Agent">
          <el-input placeholder="Name" v-model='insurer.contactPerson'>
            <template slot="prepend"><i class="fa fa-user"></i></template>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :span="7" :offset="1">
        <el-form-item label='Phone'>
          <el-input placeholder="(999)-999-9999" v-model='insurer.phone'>
            <template slot="prepend"><i class="fa fa-earphone"></i></template>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :span="7" :offset="1">
        <el-form-item label='e-Mail'>
          <el-input placeholder="person@company.com"
           v-model='insurer.email'>
            <template slot="prepend"><i class="fa fa-envelope"></i></template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
-->

  <h3>Policy Details</h3>
    <el-row v-if="adding" align="middle">
      <el-col :span="4">
        <el-form-item>
          Insurer
        </el-form-item>
      </el-col>

      <el-col :span="18">
        <select-insurer label="" v-model="insurer.organisation_id" :callback="orgChange" />
      </el-col>
    </el-row>

      <el-row align="middle">
      <el-col :span="4">
        <el-form-item>
          Policy Type
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <select-insurance-policy-type label="" v-model="insurer.policyType" />
      </el-col>
      <el-col :span="8" :offset="2">
        <text-input label="" placeholder="Policy No." v-model="insurer.policyNo" />
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4">
        <el-form-item>
          Premium
        </el-form-item>
      </el-col>

      <el-col :span="5">
          <number-input v-model='insurer.premium' />
      </el-col>
      <el-col :span="8" :offset="5">
        <select-frequency label="" v-model="insurer.frequency" />
      </el-col>
    </el-row>

    <el-row>
      <el-col align="left" :span="4">
        <el-form-item>
          Insured Amount
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item>
          <el-input-number v-model='insurer.insuredAmount' />
        </el-form-item>
      </el-col>
    </el-row>


    <el-row>
      <el-col :span="4">
        <el-form-item>
          Agreement Start
        </el-form-item>
      </el-col>

      <el-col :span="8" >
        <date-input v-model="insurer.coverageStart" />
      </el-col>


      <el-col :span="3">
        <el-form-item>
          Expiry
        </el-form-item>
      </el-col>

      <el-col :span="7" :offset="1">
        <el-form-item>
          <b>{{expiryDate}}</b>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row align="middle">
      <el-col :span="4">
        <el-form-item>
          Tenor (months)
        </el-form-item>
      </el-col>

      <el-col :span="11" :offset="1">
        <el-form-item>
          <el-slider
          v-model="tenor" :min="6" :max="240" :step="6" show-stops show-input>
        </el-slider>
      </el-form-item>
    </el-col>
    <el-col align="center":span="2">
      <el-form-item>
        <i>{{years}} yrs.</i>
      </el-form-item>
    </el-col>
  </el-row>

  </el-form>

</el-tab-pane>

</el-tabs>

</popup>
</template>



<script>
import Vue from 'vue'
import VueEvents from 'vue-events'

import ArrayMixins from '@/mixins/ArrayMixins'
import SiteMixins from '@/mixins/SiteMixins'

import SelectInsurer from '@/components/atoms/selects/SelectInsurer'
import SelectInsurancePolicyType from '@/components/atoms/selects/SelectInsurancePolicyType'

Vue.use(VueEvents)

export default {
  mixins: [ArrayMixins, SiteMixins],

  components: {
    SelectInsurer,
    SelectInsurancePolicyType
  },

  props: {

    rowData: {
      type: Object,
      default: null
    },

    siteId: {
      type: Number,
      default: null
    },

    showText: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: 'insurance-table'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  methods: {
    resetData () {
      this.insurer = this.originalAgreement
      this.insurer = this.originalInsurer
    },

    onSaveDialog () {
      this.insurer.coverageStart = this.formatDateSql(this.insurer.coverageStart)
      this.insurer.coverageEnd = this.formatDateSql(this.insurer.coverageEnd)

      if (!this.adding) {
        this.saveForm(this, '/insurance/site/' + this.insurer.site_id, this.insurer.id, this.insurer, 'Insurance Policy')
      } else {
//        console.log('adding insurer', this.insurer)
        this.saveForm(this, '/insurance', this.insurer.id, this.insurer, 'Insurance Policy')
      }

      this.$events.fire(this.tableRef + '-refresh-table')
    },

    orgChange (id, name, data) {
      if (data) {
        this.organisation = data
      }
    },

    onAdd () {
      this.adding = true
      this.editing = true
      this.resetData()
    },

    onEdit () {
      this.editing = true
    },

    onCloseDialog () {
      this.resetData()
      this.searched = false
      this.adding = false
      this.editing = false
    }
  },

  computed: {
    expiryDate: function () {
      this.insurer.coverageEnd = this.contractExpiryDate(this.insurer.coverageStart, this.tenor, 'months', 'YYYY-MM-DD')
      return this.insurer.coverageEnd
    },

    years: function () {
      return this.tenor / 12
    },

    heading: function () {
      return (this.existing ? 'Update Insurer' : 'Add Insurer')
    },

    button: function () {
      return (this.existing ? 'Update' : 'Add')
    }
  },

  data () {
    return {
      adding: (this.rowData && this.rowData.site_id ? false : true),
      editing: (this.rowData && this.rowData.site_id ? false : true),
      existing: (this.rowData && this.rowData.site_id ? true : false),
      insurer: ((this.rowData && this.rowData.site_id > 0) ? this.rowData : this.getTableStruct('insurance')),
      organisation: {},
      tenor: 12
    }
  }, // data

  created () {
    if (this.insurer && !this.insurer.site_id) {
      this.insurer.site_id = this.siteId
    }
  }
}

</script>

<style>
.el-select {display: inline-block;}
</style>



// WEBPACK FOOTER //
// InsuranceAction.vue?b0e7f080